











import { Component, Vue } from "vue-property-decorator";

import Admin from "@/mixins/Admin.vue";

@Component({ mixins: [Admin] })
export default class AdminButtons extends Vue {
  handleDelete() {
    this.$emit("delete-clicked");
  }

  handleRefresh() {
    this.$emit("refresh-clicked");
  }
}
